import React from "react";
import NumberFormat from "react-number-format";
import { Hero } from "./Leaderboard/Types";

interface Props {
  heroes: Hero[];
}

const initials = (name: string) =>
  name
    .replace(/[^\w\s]/g, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

// DOM order is 2, 1, 3 so the winner stands in the middle. Rank is carried by
// pedestal height, the gold fill and the numeral rather than reading order, and
// the whole thing reflows to a plain 1, 2, 3 list on mobile via CSS order.
const PLACES = [
  { index: 1, className: "pod-2" },
  { index: 0, className: "pod-1" },
  { index: 2, className: "pod-3" },
];

const Podium = ({ heroes }: Props) => {
  const topThree = heroes.slice(0, 3);

  // Two people is not a podium. Below three the leaderboard alone says it
  // better, so the panel steps aside rather than showing empty pedestals.
  if (topThree.length < 3) {
    return null;
  }

  return (
    <section className="panel podium-panel" aria-labelledby="podiumTitle">
      <div className="panel-top">
        <h2 id="podiumTitle">Your top three learners</h2>
        <span className="hint">By XP earned</span>
      </div>

      <div className="podium">
        {PLACES.map(({ index, className }) => {
          const hero = topThree[index];

          return (
            <div className={`pod ${className}`} key={hero.id}>
              <div className="pod-person">
                {index === 0 && (
                  <span className="pod-crown" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 7l4 4 5-7 5 7 4-4-1.5 11h-15z" />
                    </svg>
                  </span>
                )}
                <span className="pod-av">
                  {hero.profile_picture_url ? (
                    <img src={hero.profile_picture_url} alt="" />
                  ) : (
                    initials(hero.protected_name)
                  )}
                </span>
                <div className="pod-nm">{hero.protected_name}</div>
                <div className="pod-xp">
                  <NumberFormat
                    value={hero.xp}
                    displayType="text"
                    thousandSeparator
                  />{" "}
                  XP
                </div>
              </div>
              <div className="pod-stand">
                <span className="pod-num">{index + 1}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Podium;
